import { FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export const githubAuthFormFieldExtension: ExtensionDefinition =
  FormFieldBlueprint.make({
    name: 'github-auth-form-field-extension',
    params: {
      field: () => import('./github-auth').then(m => m.GithubAuthFormField),
    },
  });
